import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconTable = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.9375 0.9375H14.0625C14.625 0.9375 15 1.3125 15 1.875V13.125C15 13.6875 14.625 14.0625 14.0625 14.0625H0.9375C0.375 14.0625 0 13.6875 0 13.125V1.875C0 1.3125 0.375 0.9375 0.9375 0.9375ZM13.125 6.5625H5.625V8.4375H13.125V6.5625ZM5.625 2.8125V4.6875H13.125V2.8125H5.625ZM13.125 10.3125H5.625V12.1875H13.125V10.3125ZM1.875 12.1875H3.75V2.8125H1.875V12.1875Z",
		fill: "currentColor"
	})
});
export default SvgIconTable;
